import { Button, Modal } from "antd";
import * as ewcms from "../screen/EWCMS/styleMaster";

const defaultBtnStyle = ewcms.defaultBtnStyle;
const greyBtnStyle = ewcms.greyBtnStyle;

type ConfirmDelDraftModalProps = {
  showDelDraftModal: boolean;
  setShowDelDraftModal: (value: boolean) => void;
  title?: string;
  onConfirmDelDraft: (value: any) => void;
  isRejectedMode?: boolean;
};

const ConfirmDelDraftModal = (props: ConfirmDelDraftModalProps) => {
  const {
    showDelDraftModal,
    setShowDelDraftModal,
    title,
    onConfirmDelDraft,
    isRejectedMode,
  } = props;

  return (
    <Modal
      title={title}
      open={showDelDraftModal}
      onOk={() => setShowDelDraftModal(false)}
      onCancel={() => setShowDelDraftModal(false)}
      footer={null}
    >
      <div
        style={{
          textAlign: "left",
          paddingBottom: 15,
          margin: "25px 0 15px 0",
        }}
      >
        Please confirm if you wish to delete all the{" "}
        {isRejectedMode ? "rejected" : "drafted"} payment request(s) under this
        duty.
      </div>

      <div className="cust-spacebetween" style={{ justifyContent: "flex-end" }}>
        <Button
          className={greyBtnStyle + " cust-button-height"}
          style={{ marginRight: "10px" }}
          onClick={() => setShowDelDraftModal(false)}
        >
          Close
        </Button>
        <Button
          className={defaultBtnStyle + " cust-button-height"}
          onClick={onConfirmDelDraft}
        >
          Confirm
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmDelDraftModal;
